/**
 * ENFAMI Motion — scroll reveal, stagger, header scroll, counters, images, micro-interactions
 * Couvre : home, collection, produit, panier, footer, drawer
 */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(max-width: 989px), (hover: none)').matches;
  var scrollTicking = false;

  function revealElement(el) {
    if (!el || el.classList.contains('is-revealed')) return;
    el.classList.add('is-revealed');
  }

  function initReveal() {
    if (prefersReduced) {
      document.querySelectorAll('[data-reveal], [data-stagger]').forEach(revealElement);
      return;
    }

    var targets = document.querySelectorAll('[data-reveal], [data-stagger]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(revealElement);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealElement(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function autoTagSections() {
    var isHome = document.body.classList.contains('enfami-home');
    var isProduct = document.body.classList.contains('template-product');
    var sections = document.querySelectorAll('#MainContent > .shopify-section');

    sections.forEach(function (section, index) {
      if (isProduct && section.querySelector('.product-information')) {
        section.removeAttribute('data-reveal');
        section.classList.add('is-revealed');
        return;
      }

      if (!section.hasAttribute('data-reveal')) {
        var mode = index % 4 === 0 ? 'fade' : index % 4 === 1 ? 'scale' : '';
        section.setAttribute('data-reveal', mode);
      }

      var grids = section.querySelectorAll(
        [
          '.nm-clubs-grid',
          '.nm-nations-grid',
          '.nm-prod-grid',
          '.ef-leagues__grid',
          '.ef-promo-split__inner',
          '.ef-stats__inner',
          '.efaq__list',
          '.eht__grid',
          '.product-grid',
          '.collection-product-list',
          '.ef-footer__cols',
          '.ef-upsell__scroller',
          '.nm-coll-row',
          '.nm-clubs-row'
        ].join(', ')
      );

      grids.forEach(function (grid) {
        if (!grid.hasAttribute('data-stagger')) {
          grid.setAttribute('data-stagger', '');
        }
      });
    });

    if (isHome) {
      var banner = document.querySelector('.nm-banner, .ef-hero-slider');
      if (banner && !banner.hasAttribute('data-reveal')) {
        banner.setAttribute('data-reveal', 'scale');
      }
    }

    var footer = document.querySelector('.ef-footer');
    if (footer && !footer.hasAttribute('data-reveal')) {
      footer.setAttribute('data-reveal', 'fade');
    }
  }

  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initHeaderScroll() {
    function update() {
      var y = window.scrollY || document.documentElement.scrollTop;
      document.body.classList.toggle('ef-scrolled', y > 12);
      scrollTicking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!scrollTicking) {
          scrollTicking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function initHomeCursor() {
    /* Curseur natif — custom désactivé */
    document.body.classList.add('ef-no-cursor');
  }

  function initCardTilt() {
    if (prefersReduced || isTouch) return;

    var cards = document.querySelectorAll(
      '.ef-league-card, .ef-promo-card, .nm-nation-card, .enfami-carousel__card'
    );

    cards.forEach(function (card) {
      var host = card.closest('.ef-tilt-host') || card.parentElement;
      if (host && !host.classList.contains('ef-tilt-host')) {
        host.classList.add('ef-tilt-host');
      }
      card.classList.add('ef-tilt');

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--ef-rx', (-y * 5).toFixed(2) + 'deg');
        card.style.setProperty('--ef-ry', (x * 5).toFixed(2) + 'deg');
      });

      card.addEventListener('mouseleave', function () {
        card.style.removeProperty('--ef-rx');
        card.style.removeProperty('--ef-ry');
      });
    });
  }

  function initRipple() {
    if (prefersReduced || isTouch) return;

    var targets = document.querySelectorAll(
      '.ef-league-card, .ef-promo-card, .nm-club-card, .nm-nation-card'
    );

    targets.forEach(function (el) {
      if (getComputedStyle(el).position === 'static') {
        el.style.position = 'relative';
      }

      el.addEventListener('click', function (e) {
        var rect = el.getBoundingClientRect();
        var ripple = document.createElement('span');
        var size = Math.max(rect.width, rect.height);
        ripple.className = 'ef-ripple';
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = e.clientX - rect.left - size / 2 + 'px';
        ripple.style.top = e.clientY - rect.top - size / 2 + 'px';
        el.appendChild(ripple);
        ripple.addEventListener('animationend', function () {
          ripple.remove();
        });
      });
    });
  }

  function initMarqueePause() {
    document.querySelectorAll('.ef-usp-marquee__track').forEach(function (track) {
      track.addEventListener('mouseenter', function () {
        track.style.animationPlayState = 'paused';
      });
      track.addEventListener('mouseleave', function () {
        track.style.animationPlayState = 'running';
      });
    });
  }

  function parseStatNumber(text) {
    var cleaned = String(text || '').replace(/\s/g, '');
    var match = cleaned.match(/([\d.,]+)/);
    if (!match) return null;
    var num = parseFloat(match[1].replace(/,/g, ''));
    if (isNaN(num)) return null;
    return { value: num, raw: cleaned, suffix: cleaned.replace(match[1], '') };
  }

  function initCounters() {
    if (prefersReduced) return;

    var stats = document.querySelectorAll('.ef-stat__value');
    if (!stats.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);
          var parsed = parseStatNumber(el.textContent);
          if (!parsed) return;

          el.classList.add('is-counting');
          var start = performance.now();
          var duration = 1100;
          var from = 0;
          var to = parsed.value;
          var isInt = Number.isInteger(to);

          function tick(now) {
            var t = Math.min(1, (now - start) / duration);
            var eased = 1 - Math.pow(1 - t, 3);
            var current = from + (to - from) * eased;
            el.textContent = (isInt ? Math.round(current) : current.toFixed(1)) + parsed.suffix;
            if (t < 1) requestAnimationFrame(tick);
            else el.textContent = parsed.raw;
          }

          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.4 }
    );

    stats.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initLazyImages() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) {
        img.classList.add('ef-img-ready');
        return;
      }
      img.addEventListener(
        'load',
        function () {
          img.classList.add('ef-img-ready');
        },
        { once: true }
      );
    });
  }

  function initMagneticButtons() {
    if (prefersReduced || isTouch) return;

    var buttons = document.querySelectorAll(
      '.ef-hero-slider__btn, .eht__btn, .nm-nl-btn, .vtc__cta, .ef-promo-card__btn'
    );

    buttons.forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + x * 0.12 + 'px, ' + y * 0.12 + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  function boot() {
    autoTagSections();
    initReveal();
    initSmoothAnchors();
    initHeaderScroll();
    initMarqueePause();
    initLazyImages();

    /* Filet de sécurité : si IO rate, tout redevient visible */
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-revealed), [data-stagger]:not(.is-revealed)').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }, 2200);

    function fancy() {
      initHomeCursor();
      initCardTilt();
      initRipple();
      initCounters();
      initMagneticButtons();
    }

    if (prefersReduced || isTouch) {
      initCounters();
      return;
    }

    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(fancy, { timeout: 1800 });
    } else {
      setTimeout(fancy, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
